import { OrgAuthLoginPage } from "@solomon-apps/shared";
import * as React from "react";

import { CLIENT_OAUTH_CONFIG } from "@/constants/oauthConfig";

export function LoginPage(): React.ReactElement {
    return (
        <OrgAuthLoginPage
            config={CLIENT_OAUTH_CONFIG}
            consoleKind="client"
            appLabel="Company Recipient Console"
            footerNote="Access is restricted to authorised company recipients only."
        />
    );
}
